import { render } from "./BaseCardView.vue?vue&type=template&id=75d68b40&scoped=true"
import script from "./BaseCardView.vue?vue&type=script&lang=js"
export * from "./BaseCardView.vue?vue&type=script&lang=js"

import "./BaseCardView.vue?vue&type=style&index=0&id=75d68b40&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d68b40"],['__file',"src/components/helpers/BaseCardView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75d68b40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75d68b40', __exports__)) {
    console.log('reload')
    api.reload('75d68b40', __exports__)
  }
  
  module.hot.accept("./BaseCardView.vue?vue&type=template&id=75d68b40&scoped=true", () => {
    console.log('re-render')
    api.rerender('75d68b40', render)
  })

}


export default __exports__